import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import type {
	PetitionDetailsPageFullAddressCollectionFiltersQuery,
	PetitionDetailsPageFullAddressCollectionFiltersQueryVariables,
} from './fullAddressCollectionFilters.graphql';
import { PetitionDetailsPageFullAddressCollectionFilters } from './fullAddressCollectionFilters.graphql';

export type FullAddressCollectionFiltersResult = {
	geoReach: NonNullable<PetitionDetailsPageFullAddressCollectionFiltersQuery['petition']>['geoReach'];
	dmsWithLegislativeBodiesConnection: NonNullable<
		PetitionDetailsPageFullAddressCollectionFiltersQuery['petition']
	>['dmsWithLegislativeBodiesConnection'];
	petitionSignFormFullAddressCollection: PetitionDetailsPageFullAddressCollectionFiltersQuery['featureConfigs']['petitionSignFormFullAddressCollection'];
};

export async function getFullAddressCollectionFilters(
	utilityContext: UtilityContext,
	slugOrId: string,
): Promise<FullAddressCollectionFiltersResult> {
	const {
		gql: { fetch },
	} = utilityContext;
	const { data } = await fetch<
		PetitionDetailsPageFullAddressCollectionFiltersQuery,
		PetitionDetailsPageFullAddressCollectionFiltersQueryVariables
	>({
		query: PetitionDetailsPageFullAddressCollectionFilters,
		variables: { slugOrId },
		rejectOnError: true,
	});

	if (!data.petition) {
		throw new NotFoundError();
	}

	return {
		geoReach: data.petition.geoReach,
		dmsWithLegislativeBodiesConnection: data.petition.dmsWithLegislativeBodiesConnection,
		petitionSignFormFullAddressCollection: data.featureConfigs.petitionSignFormFullAddressCollection,
	};
}
